import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class BdspInsertionOrderService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_BDSP_URL}/insertion-order/`;

  activateDeactiveIO(
    id: number,
    action: "activate" | "deactivate",
    params = {}
  ) {
    let url = this.buildUrl(`${this.resource_url}${id}/${action}/`, "", params);
    return this.put(url, {});
  }
}
